export const Gender = {
   FEMALE: 'FEMALE',
   MALE: 'MALE',
};
